import React, { Component } from 'react';
import $ from "jquery";

class MercanciaPorteModal extends Component {

    componentDidMount = () => {
        this._handelBack();
    }
    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }

    restartTabs = () => {
        $('#nav-profile-tab-GeneralMercancia').removeClass('active');
        $('#nav-profile-tab-Adicional').removeClass('active');
        $('#nav-profile-tab-GuiasIdentificacion').removeClass('active');
        $('#nav-profile-tab-CantidadTransporta').removeClass('active');
        $('#nav-profile-tab-DetalleMercancia').removeClass('active');

        $('#nav-profile-tab-GeneralMercancia').removeClass('nav-link-current');
        $('#nav-profile-tab-Adicional').removeClass('nav-link-current');
        $('#nav-profile-tab-GuiasIdentificacion').removeClass('nav-link-current');
        $('#nav-profile-tab-CantidadTransporta').removeClass('nav-link-current');
        $('#nav-profile-tab-DetalleMercancia').removeClass('nav-link-current');

        $('#GeneralMercancia').removeClass('active');
        $('#Adicional').removeClass('active');
        $('#GuiasIdentificacion').removeClass('active');
        $('#CantidadTransporta').removeClass('active');
        $('#DetalleMercancia').removeClass('active');

        $('#GeneralMercancia').removeClass('show');
        $('#Adicional').removeClass('show');
        $('#GuiasIdentificacion').removeClass('show');
        $('#CantidadTransporta').removeClass('show');
        $('#DetalleMercancia').removeClass('show');


        $('#nav-profile-tab-GeneralMercancia').addClass('active');
        $('#GeneralMercancia').addClass('active')
        $('#GeneralMercancia').addClass('show')
    };
    closeModal = () => {
        $('#MercanciaPorteModal').modal('hide');
        this.restartTabs();
    }

    //#region FieldModel
    changeFieldModel = async (model, key, event) => {
        model[key] = event.nativeEvent.target.value;
        this.refreshModel(model);
    };
    changeFieldArrayModel = (model, key, subKey, index, event) => {
        model[key][index][subKey] = event.nativeEvent.target.value;
        this.refreshModel(model);
    };

    refreshModel = (itemModel) => {
        const { refreshModel, model } = this.props;
        model.Mercancias[itemModel.Index] = itemModel;
        refreshModel(model);
    };
    //#endregion

    //#region Render

    rendePorteItemHeader = () => {
        const { itemModel, OpenClaveProdSAT, usoInterno } = this.props;
        return (
            <div className="row">
                {/*PRIMER COLUMNA MERCANCIA*/}

                <div className="col-12 col-md-6">
                    {/*BienesTransp Mercancia*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">BienesTransp</span>
                        </div>
                        <input type="text" className="form-control"
                            disabled={usoInterno}
                            onChange={(event) => this.changeFieldModel(itemModel, 'BienesTransp', event)}
                            value={itemModel.BienesTransp ? itemModel.BienesTransp : ""}
                        />
                        {usoInterno &&
                            <div className="input-group-append" >
                                <button
                                    type="button"
                                    style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2, border: "1px solid #ced4da" }}
                                    className="btn btn-outline-secondary"
                                    onClick={() => OpenClaveProdSAT(itemModel, 0, true)}
                                    >
                                    <i className="fas fa-search fa-lg" />
                                </button>
                            </div>
                        }
                    </div>

                </div>

                {/*SEGUNDA COLUMNA SOCIOS DE NEGOCIO*/}

                <div className="col-12 col-md-6">
                    {/*Descripción Mercancia*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Descripción</span>
                        </div>
                        <input type="text" className="form-control"
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            onChange={(event) => this.changeFieldModel(itemModel, 'Descripcion', event)}
                            value={itemModel.Descripcion ? itemModel.Descripcion : ""}
                        />
                    </div>
                </div>

                <br></br>
            </div>
        )
    }

    renderPorteItemBody = () => {
        const { itemModel, OpenClaveProdSAT, usoInterno } = this.props;
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-profile-tab-GeneralMercancia"
                            data-toggle="tab"
                            href="#GeneralMercancia"
                            role="generalMercancia"
                            aria-controls="GeneralMercancia"
                            aria-selected="true">
                            General
                        </a>
                        {/* Solicitaron ocultar las pestañas de Adicional, Guías y Cantidad */}
                        {/* <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-Adicional"
                            data-toggle="tab"
                            href="#Adicional"
                            role="adicional"
                            aria-controls="Adicional"
                            aria-selected="false">
                            Adicional
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-GuiasIdentificacion"
                            data-toggle="tab"
                            href="#GuiasIdentificacion"
                            role="guiasIdentificacion"
                            aria-controls="GuiasIdentificacion"
                            aria-selected="false">
                            GuiasIdentificacion
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-CantidadTransporta"
                            data-toggle="tab"
                            href="#CantidadTransporta"
                            role="cantidadTransporta"
                            aria-controls="CantidadTransporta"
                            aria-selected="false">
                            CantidadTransporta
                        </a> */}
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-profile-tab-DetalleMercancia"
                            data-toggle="tab"
                            href="#DetalleMercancia"
                            role="detalleMercancia"
                            aria-controls="DetalleMercancia"
                            aria-selected="false">
                            DetalleMercancia
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* APARTADO GENRAL */}
                    <div className="container tab-pane active"
                        id="GeneralMercancia"
                        role="generalMercancia"
                        aria-labelledby="nav-profile-tab-GeneralMercancia"
                    >
                        {/*Primera columna*/}
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6"><br></br>
                                {/*ClaveUnidad Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ClaveUnidad</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        disabled={usoInterno}
                                        id="txtCardCode"
                                        onChange={(event) => this.changeFieldModel(itemModel, 'ClaveUnidad', event)}
                                        value={itemModel.ClaveUnidad ? itemModel.ClaveUnidad : ""}
                                    />
                                    {usoInterno &&
                                        <div className="input-group-append" >
                                            <button
                                                type="button"
                                                style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2, border: "1px solid #ced4da" }}
                                                className="btn btn-outline-secondary"
                                                onClick={() => OpenClaveProdSAT(itemModel, 1)}
                                                >
                                                <i className="fas fa-search fa-lg" />
                                            </button>
                                        </div>
                                    }
                                </div>

                                {/*ValorMercancia Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ValorMercancia</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'ValorMercancia', event)}
                                        value={itemModel.ValorMercancia ? itemModel.ValorMercancia : ""}
                                    />
                                </div>

                                {/*Dimensiones Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Dimensiones</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'Dimensiones', event)}
                                        value={itemModel.Dimensiones ? itemModel.Dimensiones : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                {/*Cantidad Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Cantidad</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'Cantidad', event)}
                                        value={itemModel.Cantidad ? itemModel.Cantidad : ""}
                                    />
                                </div>

                                {/*Moneda Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'Moneda', event)}
                                        value={itemModel.Moneda ? itemModel.Moneda : ""}
                                    />
                                </div>

                                {/*PesoEnKg Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">PesoEnKg</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'PesoEnKg', event)}
                                        value={itemModel.PesoEnKg ? itemModel.PesoEnKg : ""}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* APARTADO ADICIONAL */}
                    <div className="container tab-pane"
                        id="Adicional"
                        role="adicional"
                        aria-labelledby="nav-profile-tab-Adicional"
                    //  style={{maxHeight: 500}}
                    >
                        {/*Primera columna*/}
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6"><br></br>

                                {/*Embalaje Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Embalaje</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'Embalaje', event)}
                                        value={itemModel.Embalaje ? itemModel.Embalaje : ""}
                                    />
                                </div>

                                {/*MaterialPeligroso Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Material Peligroso</span>
                                    </div>
                                    <select className="form-control" id="MercanciaDangerous"
                                        value={itemModel.MaterialPeligroso ? itemModel.MaterialPeligroso : "No"}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'MaterialPeligroso', event)}
                                    >
                                        <option value='No'>No</option>
                                        <option value='Si'>Si</option>
                                    </select>
                                </div>

                                {/*FraccionArancelaria Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">FraccionArancelaria</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'FraccionArancelaria', event)}
                                        value={itemModel.FraccionArancelaria ? itemModel.FraccionArancelaria : ""}
                                    />
                                </div>

                                {/*ClaveSTCC Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ClaveSTCC</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'ClaveSTCC', event)}
                                        value={itemModel.ClaveSTCC ? itemModel.ClaveSTCC : ""}
                                    />
                                </div>
                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>


                                {/*DescripEmbalaje Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">DescripEmbalaje</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'DescripEmbalaje', event)}
                                        value={itemModel.DescripEmbalaje ? itemModel.DescripEmbalaje : ""}
                                    />
                                </div>

                                {/*CveMaterialPeligroso Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">CveMaterialPeligroso</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        disabled={itemModel.MaterialPeligroso !== 'Si'}
                                        value={itemModel.CveMaterialPeligroso ? itemModel.CveMaterialPeligroso : ""}
                                    />
                                </div>

                                {/*UUIDComercioExt Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UUIDComercioExt</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'UUIDComercioExt', event)}
                                        value={itemModel.UUIDComercioExt ? itemModel.UUIDComercioExt : ""}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>


                    {/* APARTADO GuiasIdentificacion */}
                    <div className="container tab-pane"
                        id="GuiasIdentificacion"
                        role="guiasIdentificacion"
                        aria-labelledby="nav-profile-tab-GuiasIdentificacion"
                    >
                        {/*Primera columna*/}
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6"><br></br>

                                {/*NumeroGuiaIdentificacion Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumeroGuiaIdentificacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'GuiasIdentificacion', 'NumeroGuiaIdentificacion', 0, event)}
                                        value={itemModel.GuiasIdentificacion ? itemModel.GuiasIdentificacion[0].NumeroGuiaIdentificacion : ""}
                                    />
                                </div>

                                {/*DescripGuiaIdentificacion Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">DescripGuiaIdentificacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'GuiasIdentificacion', 'DescripGuiaIdentificacion', 0, event)}
                                        value={itemModel.GuiasIdentificacion ? itemModel.GuiasIdentificacion[0].DescripGuiaIdentificacion : ""}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                {/*PesoGuiaIdentificacion Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">PesoGuiaIdentificacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'GuiasIdentificacion', 'PesoGuiaIdentificacion', 0, event)}
                                        value={itemModel.GuiasIdentificacion ? itemModel.GuiasIdentificacion[0].PesoGuiaIdentificacion : ""}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>


                    {/* APARTADO CantidadTransporta */}
                    <div className="container tab-pane"
                        id="CantidadTransporta"
                        role="cantidadTransporta"
                        aria-labelledby="nav-profile-tab-CantidadTransporta"
                    //  style={{maxHeight: 500}}
                    >
                        {/*Primera columna*/}
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6"><br></br>

                                {/*IDOrigen Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">IDOrigen</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'CantidadTransporta', 'IDOrigen', 0, event)}
                                        value={itemModel.CantidadTransporta ? itemModel.CantidadTransporta[0].IDOrigen : ""}
                                    />
                                </div>

                                {/*Cantidad Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Cantidad</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'CantidadTransporta', 'Cantidad', 0, event)}
                                        value={itemModel.CantidadTransporta ? itemModel.CantidadTransporta[0].Cantidad : "0"}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                {/*IDDestino Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">IDDestino</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'CantidadTransporta', 'IDDestino', 0, event)}
                                        value={itemModel.CantidadTransporta ? itemModel.CantidadTransporta[0].IDDestino : ""}
                                    />
                                </div>

                                {/*CvesTransporte Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">CvesTransporte</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldArrayModel(itemModel, 'CantidadTransporta', 'CvesTransporte', 0, event)}
                                        value={itemModel.CantidadTransporta ? itemModel.CantidadTransporta[0].CvesTransporte : ""}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* APARTADO DetalleMercancia */}
                    <div className="container tab-pane"
                        id="DetalleMercancia"
                        role="detalleMercancia"
                        aria-labelledby="nav-profile-tab-DetalleMercancia"
                    //  style={{maxHeight: 500}}
                    >
                        {/*Primera columna*/}
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            <div className="col-12 col-md-6"><br></br>

                                {/*PesoBruto Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">PesoBruto</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'PesoBruto', event)}
                                        value={itemModel.PesoBruto ? itemModel.PesoBruto : "0.00"}
                                    />
                                </div>

                                {/*PesoNeto Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">PesoNeto</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'PesoNeto', event)}
                                        value={itemModel.PesoNeto ? itemModel.PesoNeto : "0.00"}
                                    />
                                </div>

                                {/*PesoTara Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">PesoTara</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'PesoTara', event)}
                                        value={itemModel.PesoTara ? itemModel.PesoTara : "0.00"}
                                    />
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                {/*UnidadPesoMerc Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">UnidadPesoMerc</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'UnidadPesoMerc', event)}
                                        value={itemModel.UnidadPesoMerc ? itemModel.UnidadPesoMerc : "KGM"}
                                    />
                                </div>

                                {/*NumPiezas Mercancia*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumPiezas</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeFieldModel(itemModel, 'NumPiezas', event)}
                                        value={itemModel.NumPiezas ? itemModel.NumPiezas : "0"}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        )
    }

    render() {
        const { model, itemModel } = this.props;
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="MercanciaPorteModal"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS DE MERCANCIA</h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.rendePorteItemHeader()}
                                                {this.renderPorteItemBody()}
                                                <br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //#endregion
}

export default MercanciaPorteModal;